// ===========================================================================
// Clinical Note — Template Confirm (módulo TEMPORAL, va a producción)
//
// Pantalla de revisión de los 7 templates reales de nota clínica de AMD: un
// tab por template, y dentro de cada uno la nota completa con todos sus campos
// y su distribución por secciones. El catálogo de templates es una COPIA del
// del CDCI (ver templates/index.js) para que la revisión no toque el módulo
// productivo.
//
// Al terminar la revisión, borrar el módulo y quitar su entrada de
// app/routes.js y de config/navigationConfig.js.
// ===========================================================================
import React, { lazy } from "react";
import { TEMPLATE_CONFIRM_BASE_PATH } from "./common/constants";

const TemplateConfirmPage = lazy(() => import("./pages/TemplateConfirmPage"));

export const clinicalNoteTemplateConfirmRoutes = [
  { path: TEMPLATE_CONFIRM_BASE_PATH, element: <TemplateConfirmPage /> },
];

export { TEMPLATE_CONFIRM_BASE_PATH } from "./common/constants";
